export class OptIns {
  public anonymous = false;
  public showForFundraiser = false;
  public payFee = false;
  public emails = false;
  public feeAmount = 0;
}
